import { render, staticRenderFns } from "./UserBookerLeadConfig.vue?vue&type=template&id=543e68c6"
import script from "./UserBookerLeadConfig.vue?vue&type=script&lang=js"
export * from "./UserBookerLeadConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports